import React, { createContext, useContext, useState, useCallback } from 'react';
import api from '../api';

const UMAStatsContext = createContext();

export function UMAStatsProvider({ children }) {
    const [umaSize, setUmaSize] = useState(null);
    const [umaSizeLastCalculated, setUmaSizeLastCalculated] = useState(null);
    const [isRecalculating, setIsRecalculating] = useState(false);

    const fetchStats = useCallback(async () => {
        try {
            const response = await api.get('/voucher/status');
            setUmaSize(response.data.uma_size);
            setUmaSizeLastCalculated(response.data.uma_size_last_calculated);

            // Auto-trigger recalculation if last_calculated is null or > 7 days old
            if (!response.data.uma_size_last_calculated || 
                new Date(response.data.uma_size_last_calculated) < new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)) {
                recalculateUMASize();
            }
        } catch (error) {
            console.error('Error fetching UMA stats:', error);
        }
    }, []);

    const recalculateUMASize = useCallback(async () => {
        if (isRecalculating) return;
        setIsRecalculating(true);
        try {
            const response = await api.post('/users/verify-uma-size');
            setUmaSize(response.data.uma_size);
            setUmaSizeLastCalculated(response.data.uma_size_last_calculated);
        } catch (error) {
            console.error('Error recalculating UMA size:', error);
        } finally {
            setIsRecalculating(false);
        }
    }, [isRecalculating]);

    return (
        <UMAStatsContext.Provider value={{
            umaSize,
            umaSizeLastCalculated,
            isRecalculating,
            fetchStats,
            recalculateUMASize
        }}>
            {children}
        </UMAStatsContext.Provider>
    );
}

export function useUMAStats() {
    const context = useContext(UMAStatsContext);
    if (!context) {
        throw new Error('useUMAStats must be used within a UMAStatsProvider');
    }
    return context;
} 